import { PaymentTypesCard } from "./PaymentTypesCard"

enum LoanStateEnum {
  ACT = 'ACT',
  CLO = 'CLO',
  CO = 'CO'
}

enum LoanTypeEnum {
  Store = 'Store',
  Online = 'Online',
  Personal = 'Personal'
}

enum OpeningFeeTypeEnum {
  N = 'N',
  P = 'P',
  F = 'F'
}

export enum PaymentDataTypeEnum {
  Card = 'Card',
  Account = 'Account'
}

export enum InstallmentStateEnum {
  PAY = 'PAY',
  UNP = 'UNP',
  PEN = 'PEN'
}

export interface FinancialData {
  total_amount: number,
  requested_amount: number,
  pending_amount: number,
  unpaid_amount: number,
  unpaid_number: number,
  opening_fee: number,
  opening_fee_type: OpeningFeeTypeEnum,
  tin: number,
  tae: number,
  term: number,
  pending_term: number,
  regular_fee: number
}

export interface PaymentData {
  payment_day: number,
  first_due_date: string,
  last_due_date: string,
  type: PaymentDataTypeEnum,
  payment_id: string,
  iin_number: string,
  last_four_digits: string,
  expiration_date: string,
  holder: string,
  card_type: string,
  payment_method_id: string
}

export interface InstallmentData {
  order: number,
  due_date: string,
  fee: number,
  opening_fee: number,
  interest_fee: number,
  principal_fee: number,
  insurance_fee: number,
  state: InstallmentStateEnum
}

export interface ProductData {
  id: string,
  reference: string,
  name: string,
  qty: number,
  price: number,
  attributes: string
}

export interface CartData {
  id: string,
  cart_price: number,
  shipping_price: number,
  products: ProductData[]
}

export interface DirectAccessUrls {
  debt: string,
  advance_payment: string,
  cancellation: string,
  change_payment_method: string
}

export interface LoanResponse {
  loan_id: string,
  commercial_offer_id: string,
  merchant_id: string,
  alias: string,
  reference: string,
  state: LoanStateEnum,
  type: LoanTypeEnum,
  merchant_name: string,
  created_date: string,
  status_changed_date: string,
  financial_data: FinancialData,
  payment_data: PaymentData,
  installments: InstallmentData[],
  cart_data: CartData,
  direct_access_urls: DirectAccessUrls
}

export interface PaymentCard {
  consent: boolean
  consent_last_modification: string
  consent_type: string
  expiration_date: string
  holder: string
  iin_number: string
  last_four_digits: string
  payment_method_id: string
  type: PaymentTypesCard
}
export interface PaymentMethods {
  payment_methods: PaymentCard[]
}